import { createStore } from "vuex";

export default createStore({
    state: {
        loaded: false,
        projectID: 0,
        timelineProjectMapID: 0,
        settings: {
            projectViewType: {
                view: "",
                show: false
            }
        }
    }
});